if (!window.crypto) {
  window.crypto = window.msCrypto;
}

if (!navigator.maxTouchPoints) {
  navigator.maxTouchPoints = navigator.msMaxTouchPoints;
}
